import { createBrowserHistory } from 'history';
import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import reducers from './reducers';
import sagas from './sagas';
var history = createBrowserHistory();
var sagaMiddleware = createSagaMiddleware();
var middlewares = [sagaMiddleware];
var store = createStore(reducers, compose(applyMiddleware.apply(void 0, middlewares)));
sagaMiddleware.run(sagas);
if (module.hot) {
    module.hot.accept('./reducers', function () {
        var nextRootReducer = require('./reducers');
        store.replaceReducer(nextRootReducer);
    });
}
export { history, store };
